import { $color_grey_5, $color_grey_9, $color_grey_3, $color_grey_2, $color_grey_7 } from '../pebbleGlobalToken/color.js';
import { $padding_base, $spacing_l3 } from '../pebbleGlobalToken/spacing.js';

/**
 * 日期选择器-默认使用的边框颜色, 用于分割不同的元素，例如：表单的分割线、卡片的分割线等。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $date_picker_color_border = $color_grey_5;

/**
 * 日期选择器-主色梯度下的悬浮态。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $date_picker_color_primary_hover = $color_grey_9;

/**
 * 日期选择器-控制输入组件的外轮廓线颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: rgba(255, 255, 255, 0.06)
 */
var $date_picker_control_outline = 'rgba(255, 255, 255, 0.06)';

/**
 * 日期选择器-	控制输入组件错误状态下的外轮廓线颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: rgba(255, 255, 255, 0.06)
 */
var $date_picker_color_error_outline = 'rgba(255, 255, 255, 0.06)';

/**
 * 日期选择器-	控制组件项在鼠标悬浮时的背景颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-3
 */
var $date_picker_control_item_bg_hover = $color_grey_3;

/**
 * 日期选择器-SM号圆角，用于组件小尺寸下的圆角，如 Button、Input、Select 等输入类控件在 small size 下的圆角
 * @description enDesc: -
 * @description type: Border
 * @description value: 24
 */
var $date_picker_border_radius_sm = 24;

/**
 * 日期选择器-picker range 的单元hover背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $date_picker_range_cell_hover_bg = $color_grey_2;

/**
 * 日期选择器-默认使用hover的边框颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-7
 */
var $date_picker_color_border_hover = $color_grey_7;

/**
 * 日期选择器-picker timepanel cell的padding-inline-start
 * @description enDesc: -
 * @description type: Space
 * @description value: $padding_base
 */
var $date_pick_time_panel_inner_cell_padding_start = $padding_base;

/**
 * 日期选择器-picker timepanel cell的width
 * @description enDesc: -
 * @description type: Space
 * @description value: $spacing_l3
 */
var $date_pick_time_panel_inner_cell_width = $spacing_l3;

/**
 * 日期选择器-picker timepanel cell的width
 * @description enDesc: -
 * @description type: Space
 * @description value: 40
 */
var $date_pick_time_panel_cell_width = 40;

export { $date_pick_time_panel_cell_width, $date_pick_time_panel_inner_cell_padding_start, $date_pick_time_panel_inner_cell_width, $date_picker_border_radius_sm, $date_picker_color_border, $date_picker_color_border_hover, $date_picker_color_error_outline, $date_picker_color_primary_hover, $date_picker_control_item_bg_hover, $date_picker_control_outline, $date_picker_range_cell_hover_bg };
